import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationCenterApi } from '../api/notificationCenterApi';

/**
 * POST /api/eraf/notification-center/history/{id}/resend — 재발송 (NOTIFICATION_RESEND)
 * 성공 시 목록 + 상세 캐시 무효화
 */
export function useResendNotification() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => notificationCenterApi.resend(id),
    onSuccess: (_data, id) => {
      // 목록 전체 무효화 (상태 변경 반영)
      void queryClient.invalidateQueries({ queryKey: ['notification-center', 'list'] });
      // 해당 상세 캐시 무효화
      void queryClient.invalidateQueries({ queryKey: ['notification-center', 'detail', id] });
      // 통계 무효화
      void queryClient.invalidateQueries({ queryKey: ['notification-center', 'stats'] });
    },
  });
}
